export { default } from './PrintLabel';
